'use client';

import { type BlocksContent } from '@strapi/blocks-react-renderer';
import { FC } from 'react';

import CasesChunkedSlider from '@/components/CasesChunkedSlider';
import { mapCaseToSlideItem } from '@/components/CaseStudiesPage/mapCaseToSlideItem';
import TitleGraffiti from '@/components/shared/TitleGraffiti';
import { CardPreviewUsageProvider, useCardPreviewUsage } from '@/contexts/CardPreviewUsageContext';
import { useCustomCursor } from '@/hooks/useCustomCursor';

import css from './style.module.scss';
import { SliderData, WorksSliderGroup } from './types';

interface Props {
	title?: BlocksContent;
	sliderGroups: WorksSliderGroup[];
	htmlId?: string;
}

const WorksClient: FC<Props> = ({ title, sliderGroups, htmlId }) => {
	const { setCursorVariant, setIsCursorVisible } = useCustomCursor();
	const takeCardPreview = useCardPreviewUsage();

	const sliders: SliderData[] = sliderGroups.map(group => ({
		title: group.title,
		item: group.cases.flatMap(caseStudy =>
			mapCaseToSlideItem(takeCardPreview(caseStudy, `${group.title}:${caseStudy.id}`))
		)
	}));

	return (
		<section
			className={css.wrapper}
			id={htmlId}
			onMouseEnter={() => setCursorVariant('lottie-green-visit-case')}
		>
			{title ? (
				<TitleGraffiti
					title={title}
					url="/assets/video/mp4/work-graffiti.mp4"
					className={css.titleWrapper}
				/>
			) : null}

			<div id="case-studies">
				{sliders.map(slider =>
					slider.item.length ? (
						<CasesChunkedSlider
							key={slider.title}
							title={slider.title}
							items={slider.item}
							setIsCustomCursorVisible={setIsCursorVisible}
						/>
					) : null
				)}
			</div>
		</section>
	);
};

const WorksClientWithProvider: FC<Props> = props => (
	<CardPreviewUsageProvider>
		<WorksClient {...props} />
	</CardPreviewUsageProvider>
);

export default WorksClientWithProvider;
